export class AllAssessments {
    UserId:number;
    UserName:string;
    EmailId: string;
    MobileNo: string;
    Password: string;
    UserAssessmentId: string;
    AssessmentLink:string;
    AssessmentName: string;
    AssessmentCreatedDate: string;
    AssessmentCompletedDate: string;
    AssessmentStatus: string;
    TotalScore:string;
    TotalQuestions:string;
}